// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The thin scrollbar of Curio's panels and code editors: the Data Catalog's
   columns and previews, every widget panel (a node's Widgets tab, a Parameter
   node), and every node's code or spec editor. Defined here once. A panel
   takes it as the first line of its rule:
   \`composes: thinScrollbar from "<path to src>/styles/scrollbars.module.css";\`

   Chrome, Edge and Safari draw it from the ::-webkit-scrollbar rules: a 6 px
   bar that shows at rest, on a Mac too. A box that sets scrollbar-width or
   scrollbar-color turns those rules off in Chrome and Edge, which then draw
   their own bar (on a Mac, one that hides until you scroll), so the two
   standard properties are only for the browsers without ::-webkit-scrollbar
   (Firefox).

   A code editor is Monaco, which draws its bars as elements of its own, not
   the browser's. The editor carries this class too (Monaco's
   extraEditorClassName): components/editing/nodeEditorScrolling.ts gives
   Monaco the bar's 6 px and shows a bar at rest whenever the code runs past
   its side, and the last three rules here give Monaco's slider the thumb's
   colours and shape. */

/* The thumb's two colours: at rest, and under the pointer. They belong to
   this bar alone, so the class declares them rather than curioTokens.css. */
.gGn1IDkhCHnjBAv77TZw {
  --thin-thumb: rgba(30, 31, 35, 0.18);
  --thin-thumb-hover: rgba(30, 31, 35, 0.28);
}

@supports not selector(::-webkit-scrollbar) {
  .gGn1IDkhCHnjBAv77TZw {
    scrollbar-width: thin;
    scrollbar-color: var(--thin-thumb) transparent;
  }
}

.gGn1IDkhCHnjBAv77TZw::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.gGn1IDkhCHnjBAv77TZw::-webkit-scrollbar-track {
  background: transparent;
}

.gGn1IDkhCHnjBAv77TZw::-webkit-scrollbar-thumb {
  background: var(--thin-thumb);
  border-radius: 999px;
  border: 1px solid transparent;
  background-clip: padding-box;
}

.gGn1IDkhCHnjBAv77TZw:hover::-webkit-scrollbar-thumb {
  background: var(--thin-thumb-hover);
  background-clip: padding-box;
}

/* Monaco paints its slider from its theme's colours, which it declares on
   .monaco-editor. Two classes outweigh its one, so the slider takes the
   thumb's colour at rest, under the pointer and while dragged. */
.gGn1IDkhCHnjBAv77TZw.monaco-editor {
  --vscode-scrollbarSlider-background: var(--thin-thumb);
  --vscode-scrollbarSlider-hoverBackground: var(--thin-thumb-hover);
  --vscode-scrollbarSlider-activeBackground: var(--thin-thumb-hover);
}

/* With the pointer over the editor, its thumb darkens, as a panel's does. */
.gGn1IDkhCHnjBAv77TZw.monaco-editor:hover {
  --vscode-scrollbarSlider-background: var(--thin-thumb-hover);
}

/* The slider of the editor's own two bars is shaped as the thumb is: rounded,
   1 px inside its bar. Monaco sizes the slider inline, so its border goes
   inside that size. */
.gGn1IDkhCHnjBAv77TZw.monaco-editor .editor-scrollable > .scrollbar > .slider {
  border-radius: 999px;
  border: 1px solid transparent;
  background-clip: padding-box;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/styles/scrollbars.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;uBAkBuB;;AAEvB;4EAC4E;AAC5E;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE;IACE,qBAAqB;IACrB,8CAA8C;EAChD;AACF;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;;iEAEiE;AACjE;EACE,sDAAsD;EACtD,iEAAiE;EACjE,kEAAkE;AACpE;;AAEA,4EAA4E;AAC5E;EACE,4DAA4D;AAC9D;;AAEA;;sBAEsB;AACtB;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;AACxB","sourcesContent":["/* The thin scrollbar of Curio's panels and code editors: the Data Catalog's\n   columns and previews, every widget panel (a node's Widgets tab, a Parameter\n   node), and every node's code or spec editor. Defined here once. A panel\n   takes it as the first line of its rule:\n   `composes: thinScrollbar from \"<path to src>/styles/scrollbars.module.css\";`\n\n   Chrome, Edge and Safari draw it from the ::-webkit-scrollbar rules: a 6 px\n   bar that shows at rest, on a Mac too. A box that sets scrollbar-width or\n   scrollbar-color turns those rules off in Chrome and Edge, which then draw\n   their own bar (on a Mac, one that hides until you scroll), so the two\n   standard properties are only for the browsers without ::-webkit-scrollbar\n   (Firefox).\n\n   A code editor is Monaco, which draws its bars as elements of its own, not\n   the browser's. The editor carries this class too (Monaco's\n   extraEditorClassName): components/editing/nodeEditorScrolling.ts gives\n   Monaco the bar's 6 px and shows a bar at rest whenever the code runs past\n   its side, and the last three rules here give Monaco's slider the thumb's\n   colours and shape. */\n\n/* The thumb's two colours: at rest, and under the pointer. They belong to\n   this bar alone, so the class declares them rather than curioTokens.css. */\n.thinScrollbar {\n  --thin-thumb: rgba(30, 31, 35, 0.18);\n  --thin-thumb-hover: rgba(30, 31, 35, 0.28);\n}\n\n@supports not selector(::-webkit-scrollbar) {\n  .thinScrollbar {\n    scrollbar-width: thin;\n    scrollbar-color: var(--thin-thumb) transparent;\n  }\n}\n\n.thinScrollbar::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.thinScrollbar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.thinScrollbar::-webkit-scrollbar-thumb {\n  background: var(--thin-thumb);\n  border-radius: 999px;\n  border: 1px solid transparent;\n  background-clip: padding-box;\n}\n\n.thinScrollbar:hover::-webkit-scrollbar-thumb {\n  background: var(--thin-thumb-hover);\n  background-clip: padding-box;\n}\n\n/* Monaco paints its slider from its theme's colours, which it declares on\n   .monaco-editor. Two classes outweigh its one, so the slider takes the\n   thumb's colour at rest, under the pointer and while dragged. */\n.thinScrollbar:global(.monaco-editor) {\n  --vscode-scrollbarSlider-background: var(--thin-thumb);\n  --vscode-scrollbarSlider-hoverBackground: var(--thin-thumb-hover);\n  --vscode-scrollbarSlider-activeBackground: var(--thin-thumb-hover);\n}\n\n/* With the pointer over the editor, its thumb darkens, as a panel's does. */\n.thinScrollbar:global(.monaco-editor):hover {\n  --vscode-scrollbarSlider-background: var(--thin-thumb-hover);\n}\n\n/* The slider of the editor's own two bars is shaped as the thumb is: rounded,\n   1 px inside its bar. Monaco sizes the slider inline, so its border goes\n   inside that size. */\n.thinScrollbar:global(.monaco-editor) :global(.editor-scrollable > .scrollbar > .slider) {\n  border-radius: 999px;\n  border: 1px solid transparent;\n  background-clip: padding-box;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"thinScrollbar": `gGn1IDkhCHnjBAv77TZw`
};
export default ___CSS_LOADER_EXPORT___;
